import React from "react";
import Table from "../../Common/Table";

import Permission from "../../Common/Permission";
import TableFields from "../../../constants/assets/TableFields.json";
import { getPath } from "../../../utils";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const AssetList = ({ handleClick, assetList }) => {
  const allActions = MenuActionsMappings[MenuNames.ASSET_MANAGEMENT];

  const getFieldValue = (asset, key) => {
    switch (key) {
      case "actions":
        return (
          <Permission
            optionalPerms={[allActions.ASSET_MANAGEMENT]}
            notAllowedText="No Actions Allowed"
          >
            <span
              onClick={() => handleClick("Edit", asset.id)}
              className={"edit-options cursor-pointer"}
            >
              View/Edit
            </span>
          </Permission>
        );
      case "is_active":
        if (asset[key] == true) {
          return "Yes";
        } else {
          return "No";
        }

      case "upc_qr":
        if (asset[key] == true) {
          return "Yes";
        } else {
          return "No";
        }
      default:
        return getPath(asset, key, "NA");
    }
  };

  return (
    <Permission requiredPerms={[allActions.ASSET_MANAGEMENT]}>
      <Table
        list={assetList}
        getFieldValue={getFieldValue}
        fields={TableFields}
      />
    </Permission>
  );
};

export default AssetList;
